import { CoreTextView } from '@core/widgets';
import React from 'react';
import { TextStyle } from '../../../types/styles';
import styles from '../Calculator.module.css';

type TFeeBlockProps = {
    title?: string;
    text?: string;
    textColor?: string;
    rate?: string;
    icon?: React.ReactNode;
};

const FeeBlock = React.memo(({ title, text, rate, icon, textColor }: TFeeBlockProps) => {
    return (
        <div className={styles.feePanelBlock}>
            <div className={styles.feePanelBlockBottom}>
                <CoreTextView
                    text={title}
                    styleProps={{
                        ...TextStyle.secondary,
                        main: 'var(--color-grey_72_lc)',
                        textAlign: 'center',
                        margin: { bottom: 8 },
                    }}
                />
                {icon}
            </div>
            <div className={styles.feePanelBlockBottom}>
                <CoreTextView
                    text={text}
                    styleProps={{
                        ...TextStyle.secondary,
                        textAlign: 'center',
                        main: textColor ? textColor : 'var(--color-black)',
                        margin: { right: 3 },
                    }}
                />
                <CoreTextView
                    text={rate?.toUpperCase()}
                    styleProps={{
                        ...TextStyle.secondary,
                        textAlign: 'center',
                        main: textColor ? textColor : 'var(--color-black)',
                    }}
                />
            </div>
        </div>
    );
});

export { FeeBlock };
